import { Injectable, inject } from '@angular/core';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { District } from '@models/common/district.model';
import { Division } from '@models/common/division.model';
import { Observable } from 'rxjs';
import { Region } from '@models/calendar/Region.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BrookdaleFiltersService {
  api = inject(CommonVerbsApiService);
  corporationId = environment.brookdaleCorpId;

  params = {
    page: 1,
    limit: 200,
  };

  filters = [
    {
      key: 'corporation',
      values: [this.corporationId],
    },
  ];

  getRegions(): Observable<{ data: Region[] }> {
    return this.api.get<{ data: Region[] }>(
      `regions`,
      this.params,
      ['division'],
      this.filters
    );
  }

  getDistricts(): Observable<{ data: District[] }> {
    return this.api.get<{ data: District[] }>(
      `districts`,
      this.params,
      [],
      this.filters
    );
  }

  getDivisions(): Observable<{ data: Division[] }> {
    return this.api.get<{ data: Division[] }>(
      `divisions`,
      this.params,
      [],
      this.filters
    );
  }
}
